<script>
import OfferBoxCashback from "./OfferBoxCashback.vue";
import mixin from "../../components/form/steps/travel_step_mixin";
import GiftForm from "../../components/form/steps/library/fr/giftchoice/GiftForm.vue";

import {sync} from "vuex-pathify";

export default {
    components: {GiftForm, OfferBoxCashback},
    mixins: [mixin],
    props: {
        offer: {
            type: String,
            isRequired: false,
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        },
        isDesktop() {
            return !this.isMobile;
        },
        selectedGiftId: sync('form_data/gift'),
    },
}
</script>

<template>
    <div class="home-about-us-section">
        <img v-if="!isMobile" src="/images/fr_new_home/about-us.png" alt="">
        <img v-else src="/images/fr_new_home/about-us-m.png" alt="">
        <div class="home-about-us-section__content">
            <h3>Qui sommes-nous ?</h3>
            <p>Notre objectif est d'informer, de défendre et de représenter les consommateurs. Nous sommes indépendants
                de toute influence politique ou économique. Tous les bénéfices qui résultent de nos activités sont
                réinvestis dans l’accomplissement de notre mission.</p>
            <br>
            <p>Nos publications ne contiennent pas de publicité. Nous n’acceptons aucun produit gratuit, nous
                n’effectuons aucun test à la demande de fabricant. Nous ne choisissons que des laboratoires renommés,
                compétents et non liés à quelque intérêt que ce soit. Nous garantissons l'objectivité totale de nos
                évaluations et des conseils. Nos méthodes allient rigueur scientifique, compétence technique et
                efficacité. Nos analyses et études sont menées par des experts qualifiés et des spécialistes de chaque
                domaine. </p>
            <br>
            <p>Nous nous consacrons entièrement à satisfaire les besoins des consommateurs, à protéger leurs droits et
                leurs intérêts, à améliorer et à renforcer leur position sur le marché. Voilà pourquoi nous offrons des
                services de conseils individualisé et portons la voix et les intérêts des consommateurs dans tous les
                forums sociaux et institutionnels.</p>
        </div>
        <div class="start-pack">
            <div class="start-pack__left">
                <OfferBoxCashback :offer="offer"></OfferBoxCashback>
                <p class="text-uppercase centered mobile">
                    Découvrez Testachats
                </p>
                <h3><strong>Choisissez votre <br> cadeau de bienvenue</strong></h3>
                <p>parmi des dizaines de marques</p>
            </div>
            <div class="start-pack__right">
                <p v-if="isMobile" class="text-uppercase centered desktop">
                    Découvrez Testachats
                </p>
                <div v-if="isDesktop" class="gifts-dropdown">
                    <GiftForm is_dropdown></GiftForm>
                    <b-button :disabled="!selectedGiftId" class="button is-primary next-button " @click="nextStep()">
                        Demandez votre pack
                    </b-button>
                </div>
                <p class="content">Offre réservée aux nouveaux membres. <br>
                    Vous restez libre d'interrompre <br>
                    votre abonnement à tout moment.
                </p>
                <div v-if="isMobile" class="gifts-dropdown">
                    <GiftForm is_dropdown></GiftForm>
                    <b-button :disabled="!selectedGiftId" class="button is-primary next-button " @click="nextStep()">
                        Demandez votre pack
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>
